var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 421,
    height: 575,
    viewBox: "0 0 421 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_506_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M421 689L421 -166",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 689L351 -166",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281 689L281 -166",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211 689L211 -166",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141 689L141 -166",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71 689L71 -166",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 689L1 -166",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 0L-204.701 0.664879",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.281 81.3926L-205.42 82.0422",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.566 162.783L-206.134 163.433",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.855 244.176L-206.845 244.825",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.137 325.566L-207.564 326.216",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.422 406.961L-208.279 407.611",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.699 488.35L-209.002 488.999",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 574L-209.701 574.65",
    stroke: "white",
    strokeOpacity: 0.15,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_506_169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 421,
    height: 575,
    fill: "white",
    transform: "matrix(-1 0 0 1 421 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/grid.a98ba759b9a0e6a8963cbee3c1f435d8.svg";
export { ForwardRef as ReactComponent };